var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMembersLarge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.556 8.333)",
    fill: "#4A606A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.548 0c4.6 0 8.328 3.656 8.328 8.166s-3.729 8.166-8.328 8.166a8.452 8.452 0 0 1-3.032-.558c3.1-1.19 5.296-4.147 5.296-7.608 0-3.46-2.196-6.419-5.295-7.608A8.44 8.44 0 0 1 24.547 0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.452,
    cy: 8.166,
    rx: 8.328,
    ry: 8.166
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.469 18.668c5.27 0 9.531 4.178 9.531 9.37v5.806A1.17 1.17 0 0 1 38.82 35h-6.063c.65 0 1.18-.52 1.18-1.156v-5.806c0-5.192-4.261-9.37-9.532-9.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.373 18.668H9.555C4.285 18.668 0 22.87 0 28.038v5.806C0 34.48.53 35 1.18 35h28.545c.65 0 1.18-.52 1.18-1.156v-5.806c0-5.192-4.26-9.37-9.532-9.37z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMembersLarge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-members-large.309cc54770c7c25bd02b9840fde6b2b1.svg";